import styled from "styled-components";
import { pxToRem, withAlpha } from "../../styles/utils";

export const TestStack = styled.div`
  display: flex;
  flex-direction: column;
  border-top: ${pxToRem(1)} solid ${({ theme }) => theme.borders.divider};
`;

export const Question = styled.div`
  padding: ${({ theme }) => pxToRem(theme.spacing.xl)} 0;
  border-bottom: ${pxToRem(1)} solid ${({ theme }) => theme.borders.divider};
`;

export const QuestionMeta = styled.div`
  margin-bottom: ${({ theme }) => pxToRem(theme.spacing.xs)};
  color: ${({ theme }) => theme.colors.inkMuted};
  font-size: ${({ theme }) => pxToRem(theme.fontSize.xs)};
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
`;

export const QuestionText = styled.div`
  color: ${({ theme }) => theme.colors.ink};
  font-size: ${({ theme }) => pxToRem(theme.fontSize.md)};
  font-weight: 600;
  line-height: 1.45;
`;

export const QuestionComment = styled.p`
  margin: ${({ theme }) => pxToRem(theme.spacing.xs)} 0 0;
  color: ${({ theme }) => theme.colors.inkMuted};
  font-size: ${({ theme }) => pxToRem(theme.fontSize.sm)};
  line-height: 1.45;
`;

export const AttachmentLink = styled.a`
  display: inline-flex;
  margin-top: ${({ theme }) => pxToRem(theme.spacing.sm)};
  color: ${({ theme }) => theme.colors.brand};
  font-size: ${({ theme }) => pxToRem(theme.fontSize.sm)};
  font-weight: 500;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }

  &:focus-visible {
    outline: ${pxToRem(2)} solid ${({ theme }) => theme.colors.brand};
    outline-offset: ${pxToRem(2)};
    border-radius: ${({ theme }) => pxToRem(theme.radii.sm)};
  }
`;

export const Choices = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => pxToRem(theme.spacing.xs)};
  margin-top: ${({ theme }) => pxToRem(theme.spacing.md)};
`;

export const Choice = styled.label<{ $selected?: boolean }>`
  display: flex;
  align-items: flex-start;
  gap: ${({ theme }) => pxToRem(theme.spacing.sm)};
  padding: ${pxToRem(9)} ${pxToRem(10)};
  border: 0;
  border-radius: ${({ theme }) => pxToRem(theme.radii.md)};
  background: ${({ theme, $selected }) => $selected ? theme.colors.brandSubtle : "transparent"};
  color: ${({ theme }) => theme.colors.ink};
  cursor: pointer;
  font-size: ${({ theme }) => pxToRem(theme.fontSize.sm)};
  line-height: 1.45;
  transition: background-color 0.15s ease;

  &:hover {
    background: ${({ theme, $selected }) =>
      $selected ? theme.colors.brandSubtle : withAlpha(theme.colors.ink, 0.04)};
  }

  &:focus-within {
    background: ${({ theme, $selected }) =>
      $selected ? theme.colors.brandSubtle : withAlpha(theme.colors.brand, 0.06)};
  }
`;

export const ResultSummary = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: ${({ theme }) => pxToRem(theme.spacing.md)};
  padding: ${({ theme }) => pxToRem(theme.spacing.lg)} 0;
  border-bottom: ${pxToRem(1)} solid ${({ theme }) => theme.borders.divider};
`;

export const ResultPercent = styled.strong`
  color: ${({ theme }) => theme.colors.ink};
  font-size: ${pxToRem(24)};
  font-weight: 600;
`;

export const ResultDetails = styled.span`
  color: ${({ theme }) => theme.colors.inkMuted};
  font-size: ${({ theme }) => pxToRem(theme.fontSize.sm)};
`;

export const ResultState = styled.span<{ $correct: boolean }>`
  display: inline-flex;
  margin-top: ${({ theme }) => pxToRem(theme.spacing.sm)};
  color: ${({ theme, $correct }) => $correct ? theme.colors.successText : theme.colors.dangerText};
  font-size: ${({ theme }) => pxToRem(theme.fontSize.sm)};
  font-weight: 600;
`;

export const SelectedAnswer = styled.div`
  margin-top: ${({ theme }) => pxToRem(theme.spacing.xs)};
  color: ${({ theme }) => theme.colors.inkSoft};
  font-size: ${({ theme }) => pxToRem(theme.fontSize.sm)};
  line-height: 1.45;
`;
